module.exports = __webpack_public_path__ + "static/media/avatar_agent.473ea396.webp";